import { repository } from 'aurelia-orm';

@repository(History)
export class History {
	id: number;
	itemId: number;
	historyTypeId: number;
	inserted: Date;
	columnName: string;
	originalValue: string;
	newValue: string;
	tenantId: number;
	appUserId: number;
	content: string;
	
}